import React, { useEffect, useState } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import ImageUploadPreview from "@component/ImageUploadPreview";
import ImagePlaceholder from "@component/ImagePlaceholder";
import ErrorWrapper from '@component/ErrorWrapper';
import { SmartFormStates } from './SmartForm';
import { syncValidatorResults } from "@component/smartForm/validatorUtils";

const SmartImageUpload = ({
  field,
  label,
  value = null,
  onChange,
  isEdit,
  sx = {},
  mode = "show",
  renderCustom,
  previewProps = {},
  editable = true,
  imageSx = {},
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  ...props
}) => {
  const [showError, setShowError] = useState(false);
  const [validatorResult, setValidatorResult] = useState("");

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);

  useEffect(() => {
    if (validator) {
      const result = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !result, label || field);
      setValidatorResult(result);
    }
  }, [value, validator, validatorResults, setValidatorResults, label, field]);

  const handleUpload = (uuid) => {
    onChange(field, uuid);
  };

  const handleDelete = () => {
    onChange(field, null);
  };

  const renderPreview = () => {
    if (value) {
      return (
        <ImageUploadPreview
          mode={mode}
          fileUuid={value}
          renderCustom={renderCustom}
          imageSx={imageSx}
          {...previewProps}
        />
      );
    } else {
      return (
        <Avatar
          variant="rounded"
          alt="Placeholder"
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 40,
            bgcolor: "#f0f0f0",
            color: "#9e9e9e",
            mx: "auto",
            ...imageSx
          }}
        >
          <ImagePlaceholder/>
        </Avatar>
      );
    }
  };

  const renderContent = () => {
    if (!isEdit || !editable) {
      return renderPreview();
    } else {
      return (
        <ImageUploadPreview
          mode="edit"
          fileUuid={value}
          onUpload={handleUpload}
          onDelete={handleDelete}
          renderCustom={renderCustom}
          imageSx={imageSx}
          {...props}
        />
      );
    }
  };

  return (
    <Box sx={sx}>
      {label && <Typography variant="h6" gutterBottom>{label}</Typography>}
      {isEdit && editable ? (
        <ErrorWrapper message={validatorResult} showMessage={showError}>
          {renderContent()}
        </ErrorWrapper>
      ) : (
        renderContent()
      )}
    </Box>
  );
};

export default SmartImageUpload;
